exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#calendrier .status{font-weight:700;color:#f30}#calendrier .status.open{color:#62c647}", ""]);

// exports
